import LinearProgress from "@material-ui/core/LinearProgress";
import React from "react";
import TitlePage from "../../../app/Title/TitlePage";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
    amountDataTableTemplate, numberWithCommaDataTableTemplate,
    priceDataTableTemplate, rateDataTableTemplate,
} from "../../../utils/formatters/Numbers";
import {Divider} from "@material-ui/core";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import {Checkbox} from "primereact/checkbox";

const BilateralBidAdminView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            {props.messagesGrowl}
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <TitlePage title="Bilaterales \ Posturas Administrativas"/>
                    </Grid>
                    <Grid item xs={6}>
                        <Button
                            label="Buscar"
                            style={{'float': 'right'}}
                            onClick={props.getDataBidAdmin}
                        />
                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    <Grid item xs={10}>
                        <Typography variant="subtitle2" gutterBottom style={{fontWeight: "bolder", float: 'right'}}
                                    className={"secondary-text"}>
                            <Checkbox name="source"
                                      checked={props.source}
                                      onChange={props.onChangeSource}
                            />&nbsp;
                            Administrativas
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            label="Insertar postura / hecho"
                            style={{'float': 'right'}}
                            onClick={props.redirectAddBidAdmin}
                            className="p-button-secondary"/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            responsive={true}
                            value={props.dataBidAdmin}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="lenderShortName" header="Prestamista"
                                    style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="borrowerShortName" header="Prestatario"
                                    style={{textAlign: 'left'}}
                                    sortable={true}/>
                            <Column field="status" header="Estatus"
                                    style={{textAlign: 'left'}}
                                    sortable={true}/>
                            <Column field="composeName" header="Emisora"
                                    style={{textAlign: 'left'}}
                                    sortable={true}/>
                            <Column field="titles" header="Títulos"
                                    style={{textAlign: 'left'}}
                                    body={numberWithCommaDataTableTemplate}
                                    sortable={true}/>
                            <Column field="rate" header="Tasa"
                                    style={{textAlign: 'left'}}
                                    body={rateDataTableTemplate}
                                    sortable={true}/>
                            <Column field="todayPrice" header="Precio"
                                    style={{textAlign: 'left'}}
                                    body={priceDataTableTemplate}
                                    sortable={true}/>
                            <Column field="amount" header="Total"
                                    style={{textAlign: 'left'}}
                                    body={amountDataTableTemplate}
                                    sortable={true}/>
                            <Column header="Acciones"
                                    style={{textAlign: 'center', width: '8em'}}
                                    body={props.bilateralBidAdminActionTemplate}/>
                        </DataTable>
                    </Grid>
                    {props.confirmationMsg}
                </Grid>
            </Paper>

        </React.Fragment>
    )
};

export default BilateralBidAdminView;

BilateralBidAdminView.propTypes = {
    getDataBidAdmin: PropTypes.func.isRequired,
    redirectAddBidAdmin: PropTypes.func.isRequired,
    dataBidAdmin: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    messagesGrowl: PropTypes.object,
    bilateralBidAdminActionTemplate: PropTypes.func.isRequired,
    confirmationMsg: PropTypes.object,
    source: PropTypes.bool.isRequired,
    onChangeSource: PropTypes.func.isRequired
}